import { Component, OnInit } from '@angular/core';
import { BillingService } from '../../../../services/billing.service';
import { LookupService } from '../../../../services/lookup.service';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { UserService } from '../../../../services/user.service';
import { Router } from '@angular/router';
import { ReportFiltersComponent } from '../report-filters/report-filters.component';

@Component({
  selector: 'ppl-summary-report',
  standalone: true,
  imports: [NzFormModule, FormsModule, NzSelectModule, ReportFiltersComponent],
  templateUrl: './summary-report.component.html',
  styleUrl: './summary-report.component.css',
})
export class SummaryReportComponent implements OnInit {
  mcoList: any;
  programName: any;
  mcoName: any;
  selectedClaimType: any = 'All';
  claimTypes = ['All', 'SC', 'PMPM'];
  summaryReportData: any;
  filterFields = [
    { field: 'mcoName', show: true, default: '' },
    { field: 'selectedClaimType', show: true, default: 'All' },
  ];

  constructor(
    private lookupService: LookupService,
    private billingService: BillingService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.lookupService.getOrgData(this.programName).subscribe((data: any) => {
      if (data.status === 200) {
        this.mcoList = data.responsedata.filter((item: any) => item.orgTypeLookup === 'MCO');
        this.mcoName = this.mcoList[0]?.orgName;
        this.filterFields = this.filterFields?.map(f =>
          f.field === 'mcoName' ? { ...f, default: this.mcoList[0]?.orgName } : f
        ) ?? [];
        this.getSummaryData();
      }
    });
  }

  getSummaryData() {
    const options = {
      reportName: 'fetchSummaryReport',
      mcoName: this.mcoName,
      claimType: this.selectedClaimType,
      programCode: this.programName
    };
    this.billingService.getReports(options).subscribe((data: any) => {
      this.summaryReportData =
        this.generateGenericSummaryItems(data.responsedata[0]) || [];
    });
  }

  generateGenericSummaryItems(data: Record<string, any>): any[] {
    const formatNumber = (val: any) => Number(val).toLocaleString('en-US');

    const formatCurrency = (val: any) => {
      const num = Number(val);
      return isNaN(num)
        ? val
        : `$${num.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
    };

    const formatKeyName = (key: string): string =>
      key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());

    return Object.entries(data).map(([key, value]) => {
      const isCurrency =
        key.toLowerCase().includes('amount') ||
        key.toLowerCase().includes('billed') ||
        key.toLowerCase().includes('paid') ||
        key.toLowerCase().includes('denied') ||
        key.toLowerCase().includes('total');

      let formattedValue: any = value;

      if (value !== null && value !== undefined && value !== '') {
        formattedValue =
          typeof value === 'number' || !isNaN(value)
            ? isCurrency
              ? formatCurrency(value)
              : formatNumber(value)
            : value;
      } else {
        formattedValue = null;
      }

      return {
        id: key,
        itemName: formatKeyName(key),
        value: formattedValue,
        description: '',
      };
    });
  }

  filterChanged(change: any) {
    this.mcoName = change.formValues.mcoName;
    this.selectedClaimType = change.formValues.selectedClaimType;
    if (change.field === 'mcoName' || change.field === 'selectedClaimType') {
      this.getSummaryData();
    }
  }

  formatKeyName(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  }

  onClick(item: any) {
    const routeMap: Record<string, string> = {
      batchCount: '/home/claimBatchesList',
      recentBatchRunDate: '/home/batchReport',
      currentIgnoredTimesheetCount: '/home/ignoredTimesheetReport',
      timesheetsCount: '/home/activityBillingReport',
      claimsCount: '/home/activityBillingReport',
      memberCount: '/home/activityBillingReport',
      totalBilled: '/home/activityBillingReport',
      totalPaid: '/home/activityBillingReport',
      totalDenied: '/home/denialBillingReport',
      totalTimesheetPaid: '/home/activityBillingReport'
    };
  
    const route = routeMap[item.id];
    const data = { type: item.id } as any;
    if(item.id === 'recentBatchRunDate') {
      data.type = item.value;
    }
    // if(this.mcoName !== 'All') {
      data.mco = this.mcoName
    // }
    if(this.selectedClaimType !== 'All') {
      data.pmpm = this.selectedClaimType;
    }
    if (route) {
      this.router.navigate([route],{
        state: data
      });
    }
  }
}
